var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "car") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,14.6923077 C7.71502645,14.6923077 8.7,15.6566175 8.7,16.8461538 C8.7,18.0356902 7.71502645,19 6.5,19 C5.28497355,19 4.3,18.0356902 4.3,16.8461538 C4.3,15.6566175 5.28497355,14.6923077 6.5,14.6923077 Z M17.5,14.6923077 C18.7150264,14.6923077 19.7,15.6566175 19.7,16.8461538 C19.7,18.0356902 18.7150264,19 17.5,19 C16.2849736,19 15.3,18.0356902 15.3,16.8461538 C15.3,15.6566175 16.2849736,14.6923077 17.5,14.6923077 Z M14.6966928,5 C15.1535805,5 15.5629031,5.28242675 15.7250708,5.70956602 L17.5,10.3846154 L21.9,10.3846154 C22.5075132,10.3846154 23,10.8771022 23,11.4846154 L23,15.7461538 C23,16.3536671 22.5075132,16.8461538 21.9,16.8461538 L20.8,16.8461538 C20.8,15.0618493 19.3225397,13.6153846 17.5,13.6153846 C15.6774603,13.6153846 14.2,15.0618493 14.2,16.8461538 L9.8,16.8461538 C9.8,15.0618493 8.32253967,13.6153846 6.5,13.6153846 C4.67746033,13.6153846 3.2,15.0618493 3.2,16.8461538 L2.1,16.8461538 C1.49248678,16.8461538 1,16.3536671 1,15.7461538 L1,10.3846154 L2.77168503,5.71014755 C2.93369179,5.28270397 3.34316853,5 3.80028362,5 L14.6966928,5 Z M8.7,6.076 L4.6234414,6.07692308 C4.20326073,6.07692308 3.82382268,6.31571072 3.63934387,6.68537065 L3.59000322,6.80008688 L2.28292931,10.3846154 L8.7,10.3846154 L8.7,6.076 Z M13.6640187,6.07692308 L9.8,6.076 L9.8,10.3846154 L16.0578236,10.3846154 L14.6924572,6.7866484 C14.545072,6.39826418 14.1933553,6.12948323 13.7873116,6.08382376 L13.6640187,6.07692308 Z",
    id: "Combined-Shape",
    fill: "#585858"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.37dfc9ee.svg";
export { ForwardRef as ReactComponent };